import React from 'react';
import { createStyles, makeStyles, Theme, Grid, CircularProgress } from '@material-ui/core';
import PaperColumn from './PaperColumn';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    outer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '50px',
    },
    spinner: {
      margin: '0 auto',
    }
  })
);

const LoadingSpinner: React.FunctionComponent = () => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <PaperColumn>
          <div className={classes.outer}>
            <CircularProgress className={classes.spinner} />
          </div>
        </PaperColumn>
      </Grid>
    </Grid>
  );
};

export default LoadingSpinner;